import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { UserService } from '../api-services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptService implements HttpInterceptor {
  /** Inject services. */
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.userService.authToken();
    if (token) {
      req = req.clone({
        setHeaders: { Authorization: 'Bearer ' + token },
      });
    }
    return next.handle(req).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.userService.clearSession();
            this.router.navigate(['login']);
          }
        }
        return throwError(() => err);
      })
    );
  }
}
